import React from "react";
import { Button, useTheme } from "@mui/material";
import { FaPaperPlane } from "react-icons/fa";

const SubmitButton = ({
    label = "Enviar",
    fullWidth = false,
    disabled = false,
    fullHeight = false,
    ml = 0,
    mr = 0,
    mt = 0,
    size = "medium",
    color = "primary"
}) => {

    const theme = useTheme();

    return (
        <Button
            variant="contained"
            color={color}
            endIcon={<FaPaperPlane size="12px" />}
            fullWidth={fullWidth}
            disabled={disabled}
            sx={{
                marginTop: theme.spacing(mt),
                marginLeft: theme.spacing(ml),
                marginRight: theme.spacing(mr),
                height: fullHeight ? "100%" : undefined
            }}
            type="submit"
            size={size}
        >
            {label}
        </Button>
    );
}

export default SubmitButton;
